import React from 'react';

import MobileListFilter from '../../listSidebar/mobile';
import FullScreenMobileModal from '../fullScreenMobileModal';

const CreateListMobileMenu = ({ type }) => <FullScreenMobileModal type={type} content={<MobileListFilter />} />;

export default CreateListMobileMenu;
